export default __webpack_public_path__ + "static/media/countdown-bg.f79107e3.png";